export default "__VITE_ASSET__ebmppSM6__"